import { useEffect, useState } from "react";
import { loadScenarios, peekScenarios } from "@/lib/whatif/dataset";
import type { WhatIfScenario } from "@/lib/whatif/types";

/** Loads the static scenario dataset once per session. No backend involved. */
export function useWhatIfScenarios() {
  const [data, setData] = useState<WhatIfScenario[] | undefined>(() => peekScenarios());
  const [error, setError] = useState(false);

  useEffect(() => {
    if (data) return;
    let alive = true;
    loadScenarios()
      .then((d) => alive && setData(d))
      .catch(() => alive && setError(true));
    return () => {
      alive = false;
    };
  }, [data]);

  return { scenarios: data, error };
}